import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { FaArrowLeft, FaGlobe, FaSave } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddDistrict = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    district_name: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.district_name.trim()) {
      newErrors.district_name = "District name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    setSubmitting(true);

    try {
      const data = await apiFetch("super_admin/add_district", {
        method: "POST",
        body: JSON.stringify({ district_name: formData.district_name.trim() }),
      });

      alert(data.message || "District added successfully");
      navigate("/district-list");
    } catch (error) {
      alert(error.message || "Failed to add district");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3 admin-form-container">
        {/* Header Card with Left Back Arrow */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                onClick={() => navigate("/district-list")}
                className="btn-admin-back"
                title="Back to District List"
              >
                <FaArrowLeft /> <span>मागे जा (Back)</span>
              </button>

              <div className="admin-header-icon">
                <FaGlobe />
              </div>

              <div>
                <h4 className="text-white fw-bold mb-0" style={{ fontSize: "1.25rem" }}>
                  नवीन जिल्हा जोडा / Add District
                </h4>
                <p className="text-white-50 mb-0 small">
                  District master registration
                </p>
              </div>
            </div>

            <Link to="/district-list" className="btn btn-outline-light btn-sm fw-semibold rounded-pill px-3">
              District List / यादी
            </Link>
          </div>
        </div>

        {/* Form Card */}
        <div className="admin-form-card">
          <div className="card-body">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* District Name */}
                <div className="col-md-6">
                  <label className="admin-form-label">
                    District Name / जिल्ह्याचे नाव <span className="required-star">*</span>
                  </label>

                  <input
                    type="text"
                    className={`admin-form-control ${errors.district_name ? "border-danger" : ""}`}
                    name="district_name"
                    placeholder="e.g. Pune, Mumbai, Thane / पुणे, मुंबई, ठाणे"
                    value={formData.district_name}
                    onChange={handleChange}
                  />
                  {errors.district_name && (
                    <small className="text-danger fw-semibold d-block mt-1">{errors.district_name}</small>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 pt-3 border-top">
                <Link to="/district-list" className="btn-admin-cancel">
                  रद्द करा (Cancel)
                </Link>
                <button
                  type="submit"
                  className="btn-admin-submit"
                  disabled={submitting}
                >
                  <FaSave />
                  <span>{submitting ? "जतन होत आहे..." : "जतन करा (Save District)"}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddDistrict;
